import ReactDOM  from "react-dom";
function ConsentModal(props){
   const modalRoot = document.getElementById("consent-root");
   return ReactDOM.createPortal(props.children,modalRoot)
}

export default ConsentModal;